export default {
  items: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer',
      accountTypeAccess: [1, 2]
    },
    {
      name: 'MemberList',
      url: '/member-list',
      icon: 'icon-people',
      accountTypeAccess: [1, 2]
    },
    {
      name: 'Realtime',
      url: '/realtime',
      icon: 'icon-hourglass',
      accountTypeAccess: [1]
    },
    {
      name: 'Performance',
      url: '/performance',
      icon: 'icon-globe',
      accountTypeAccess: [1]
    },
    {
      name: 'Advertisement',
      url: '/advertisement',
      icon: 'fa fa-newspaper-o',
      accountTypeAccess: [1, 2]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/_nav.js